module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Dinner-8f441ff656bab1dd91f029a5c8f67b47a1dfabb6eb26b38caac3985898137e5c.svg";